
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { ElMessage } from "element-plus";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { POINT_LABEL } from "@/core/config/labels";
import ApiService from "@/core/services/ApiService";
import type { ElForm } from "element-plus";

type FormInstance = InstanceType<typeof ElForm>;

const pointLabel = POINT_LABEL

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs(`${pointLabel}新增`, [`${pointLabel}管理;add_point_records`])
    })

    const validateMobile = (rule: any, value: any, callback: any) => {
      if (!value) {
        callback(new Error("手机号码不可为空"));
      } else if (!/^\d+$/.test(value)) {
        callback(new Error("手机号码必须为数字"));
      } else {
        callback();
      }
    };

    const validatePoint = (rule: any, value: any, callback: any) => {
      const num = Number(value);
      if (!value && value !== 0) {
        callback(new Error(`${pointLabel}数量不可为空`));
      } else if (!Number.isInteger(num) || num <= 0) {
        callback(new Error(`${pointLabel}数量必须为正整数`));
      } else {
        callback();
      }
    };

    const rules = ref({
      mobile: [
        { validator: validateMobile, trigger: "blur" },
      ],
      point: [
        { validator: validatePoint, trigger: "blur" },
      ],
    });

    const formRef = ref<FormInstance>()
    const store = useStore()
    const router = useRouter()
    const add_point_record = ref({
      mobile: "",
      point: 0,
      note: "",
      record_type: "gain"
    })

    const confirmDialogVisible = ref(false)
    const lookupUser = ref<any>(null)
    const lookupLoading = ref(false)
    const submitting = ref(false)

    const onCancel = () => {
      router.push({ name: "add_point_records" })
    }

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (!formEl) return

      formEl.validate(async (valid) => {
        if (!valid) return false

        lookupLoading.value = true
        try {
          ApiService.setHeader()
          const { data } = await ApiService.get(
            "admin/users",
            `lookup?mobile=${add_point_record.value.mobile}`
          )
          if (data.success && data.user) {
            lookupUser.value = data.user
            confirmDialogVisible.value = true
          } else {
            ElMessage.error(data.error_msg || "未找到该手机号对应的用户")
          }
        } catch (e) {
          ElMessage.error("用户查询失败，请检查手机号是否正确")
        } finally {
          lookupLoading.value = false
        }
      })
    }

    const doCreate = () => {
      submitting.value = true
      const params = {
        add_point_record: {
          ...add_point_record.value
        }
      }

      store
        .dispatch(Actions.CREATE_ADD_POINT_RECORD, params)
        .then(() => {
          confirmDialogVisible.value = false
          router.push({ name: "add_point_records" })
        })
        .catch(() => {
          Swal.fire({
            text: store.getters.getErrors,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "确认",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          })
        })
        .finally(() => {
          submitting.value = false
        })
    }

    return {
      pointLabel,
      onSubmit,
      add_point_record,
      rules,
      onCancel,
      formRef,
      confirmDialogVisible,
      lookupUser,
      lookupLoading,
      submitting,
      doCreate,
    }
  },
})
